import {
  captureCheckoutError,
  CheckoutErrorCategory,
} from "../common/utils/sentry.utils";

type TagKeys = "errorType" | "code";

/**
 * @deprecated Use captureCheckoutError from common/utils/sentry.utils instead
 */
export function handleSentryError(
  message: string,
  error?: unknown,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tags?: Partial<Record<TagKeys, any>>
) {
  captureCheckoutError({
    message,
    error,
    context: {
      checkoutType: "express",
      category:
        (tags?.errorType as CheckoutErrorCategory) ?? "payment_creation",
      errorCode: tags?.code,
    },
  });
}
